/* Knockout binding for modal windows.
Usage:
<a href=""
    data-bind="modal2: {
        model: object or observable, // knockout model for modal window
        template: 'template-id', // modal window template id
        component: 'component-id' // modal window component id
        preRender: function, // this function is called before popup is opened
                            // if not specified model.preRender will be used
        pageTitle: string, // this value will be shown as page title when rendred as page
                           // if not specified model.pageTitle will be used
    }">
    add receipt
</a> */

/* WCP-1621: Next line was added because we don't use mobile positioning for modal windows (in mobile versions we use our own popups). That's why MagnificPopups script must think that users work only on desktop. */
$.magnificPopup.instance.probablyMobile = false;

ko.bindingHandlers.modal2 = {

    init: function (element, valueAccessor) {
        var headersContainer = [];
        var options = valueAccessor();
        var showAsPage = options.showAsPage || $.cdh.isMobile;

        function render(el, closeFunc, model) {
            var template = getTemplate(options);
            var sourceModel = ko.unwrap(model);

            var setClose = sourceModel.setClose;
            if ($.isFunction(setClose)) {
                setClose(closeFunc);
            }
            else if (sourceModel.params) {
                sourceModel.params.closeFunc = closeFunc;
            }

            var preRender = options.preRender || sourceModel.preRender;
            if ($.isFunction(preRender))
                preRender();

            ko.renderTemplate(template, model, null, el, 'replaceChildren');
        }

        function getTemplate(options) {
            return options.component ? 'template-modal2-to-component' : options.template;
        }

        function getModel(options) {
            var model = options.modelBuilder ? options.modelBuilder() : options.model;
            if (options.component) {
                var componentModel = {
                    component: options.component,
                    params: model
                };
                if (model) {
                    componentModel.preRender = model.preRender;
                    componentModel.pageTitle = model.pageTitle;
                }
                return componentModel;
            }

            return model;
        }

        function setPageTitle(title, content, selector) {
            var titleText = ko.unwrap(title);
            if (titleText)
                $(content).find(selector).text(titleText);
        }

        function isDisable() {
            let disable = ko.unwrap(options.disable);
            if (disable) {
                $(element).removeAttr("href");
            }
            return disable;
        }

        if (showAsPage) {
            var mainContent = $("#main-content");
            var popupContent = $("#popup-content");
            var $metaTitle = $('title');
            
            var scrollPosition = 0;
            var titleSubscription = null;

            function close() {
                if (titleSubscription && $.isFunction(titleSubscription.dispose)) {
                    titleSubscription.dispose();
                }
                mainContent.show();
                popupContent.hide();
                
                $.cdh.helper.handleHeadingLevelOnPageStateChange(popupContent, false);
                var title = headersContainer.pop();
                $.cdh.helper.titlePage(title);

                const storedTitle = $metaTitle.data('title');

                if(storedTitle) {
                    $metaTitle.text(storedTitle);
                    $metaTitle.removeData('title');
                }

                if (scrollPosition) {
                    window.scrollTo(0, scrollPosition);
                }
            }

            $(element).on("click", function () {
                let disable = isDisable();
                if (disable) return false;

                var model = getModel(options);
                var prevTitle = $(".title-page").text();
                headersContainer.push(prevTitle);
   
                render(popupContent[0], close, model);

                var title = options.pageTitle || ko.unwrap(model).pageTitle;
                if (ko.isObservable(title)) {
                    titleSubscription = title.subscribe($.cdh.helper.titlePage);
                }
                $.cdh.helper.handleHeadingLevelOnPageStateChange(popupContent, true);
                $.cdh.helper.titlePage(ko.unwrap(title));
                const metaTitleText = $metaTitle.text();
                const metaTitlePagePart = metaTitleText.split(' | ')[0];
                const newMetaTitle = metaTitleText.replace(metaTitlePagePart, title);
                $metaTitle.data('title', metaTitleText).html(newMetaTitle);

                scrollPosition = $(window).scrollTop();
                mainContent.hide();
                popupContent.show();
                tooltipsInit();
                window.scrollTo(0, 0);

                return false;
            });

        } else {
            $(element).magnificPopup({
                enableEscapeKey: false,
                closeOnBgClick: false,
                items: {
                    src: '<div></div>',
                    type: 'inline'
                },
                callbacks: {
                    open: function (item) {
                        var renderIn = this.content[0];
                        var model = getModel(options);
                        var magnificPopup = this;
                        var titleId = 'popup-form_title'; /* + Date.now()*/
                        var closeEscButton = $.cdh.languageConstant.getConstant('button.close-esc');

                        render(renderIn, this.close, model);
                        setTimeout(function() {
                           
                            var title = options.pageTitle || ko.unwrap(model).pageTitle;
                            if (title && title.length > 0)
                                setPageTitle(title, $(".magnific-popup-container"), ".popup-form_title");

                            tooltipsInit();
                            var popupContainer = $(renderIn).find('.magnific-popup-container');
                            popupContainer.find('.popup-form_title').attr('id', titleId).after(
                                '<button title= ' + closeEscButton + ' type="button" class="mfp-close" aria-label="close">×</button>'
                            );
                            $(popupContainer).on("click keydown", function (e) {
                                var firstFocusable = $(popupContainer).find('.mfp-close');
                                var lastFocusable = $(popupContainer).find(':focusable').eq(-1);
                                if (document.activeElement === firstFocusable[0] && e.shiftKey && e.key === 'Tab') {
                                    lastFocusable.focus();
                                    e.preventDefault();
                                }

                                else if (document.activeElement === lastFocusable[0] && e.key === 'Tab' && !e.shiftKey) {
                                    firstFocusable.focus();
                                    e.preventDefault();
                                }
                            })
                            
                            if (popupContainer.length) {
                                popupContainer.attr({
                                    'role': 'dialog',
                                    'aria-modal': 'true',
                                    'aria-labelledby': titleId
                                });
                            }
                            // popupContainer.attr('role', 'dialog').attr('aria-modal', 'true').attr('aria-labelledby', 'popup-form_title');
                            // $.cdh.helper.updateMagnificPopupBgHeight();
                        }, 0);
                    }
                },
                disableOn: function () {
                    return !isDisable();
                }
            });
        }

        $(element).on("click", function (e) { e.stopImmediatePropagation(); });

        $(element).on('keydown', function (e) {
            if (e.keyCode === 32 || e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                $(element).click();
            }
        });

        let forceOpen = options.forceOpen;
        if(ko.isSubscribable(forceOpen)) {
            forceOpen.subscribe(function(newValue) {
                if(newValue === true) {
                    $(element).click();
                }
            });

            if (forceOpen() === true)
                $(element).click();
        }
        else if (forceOpen) {
            $(element).click();
        }
    }
};

ko.bindingHandlers.modalComponent = {

    init: function (element, valueAccessor) {
        var headersContainer = [];
        var options = valueAccessor();
        var showAsPage = options.showAsPage || $.cdh.isMobile;

        function render(el, closeFunc, model) {
            var template = getTemplate(options);

            model = model || {};

            model.closeFunc = closeFunc;

            const root = document.createElement('div');
            root.setAttribute('id', 'pop15');
            root.setAttribute('class', `popup-form magnific-popup-container ${options.css}`);
            root.setAttribute('role', 'dialog');
            root.setAttribute('aria-modal', 'true');
            root.setAttribute('aria-labelledby', 'popup-form_title');
            
            const title = document.createElement('h1');
            title.setAttribute('class', 'popup-form_title');
            title.setAttribute('id', 'popup-form_title');
            title.innerHTML = options.title;

            const body = document.createElement('div')
            body.setAttribute('class', 'popup-form_content');

            /*var wrap = document.querySelector('.mfp-wrap');
            if (wrap) {
                wrap.setAttribute('role', 'dialog');
                wrap.setAttribute('aria-modal', 'true');
                wrap.setAttribute('aria-labelledby', 'popup-form_title');
            }*/
            
            const component = document.createElement(template);
            component.setAttribute('params', getModelProps(model));
            body.appendChild(component);

            root.appendChild(title);
            root.appendChild(body);

            ko.applyBindings(model, root);

            el.innerHTML = '';
            el.appendChild(root);

        }

        function getModelProps(model){
            const keys = Object.keys(model);
            return keys.map(function (k) {
                return k + ': ' + k;
            }).join(', ');
        }

        function getTemplate(options) {
            return options.component;
        }

        function getModel(options) {
            return options.params;
        }

        function setPageTitle(title, content, selector) {
            var titleText = ko.unwrap(title);
            if (titleText)
                $(content).find(selector).text(titleText);
        }

        if (showAsPage) {
            var mainContent = $("#main-content");
            var popupContent = $("#popup-content");
            var scrollPosition = 0;
            var titleSubscription = null;

            function close() {
                if (titleSubscription && $.isFunction(titleSubscription.dispose)) {
                    titleSubscription.dispose();
                }
                mainContent.show();
                popupContent.hide();
                var title = headersContainer.pop();
                $.cdh.helper.titlePage(title);
                if (scrollPosition) {
                    window.scrollTo(0, scrollPosition);
                }
            }

            $(element).on("click", function () {
                let actualOptions = valueAccessor();
                let model = getModel(actualOptions);
                let prevTitle = $(".title-page").text();
                headersContainer.push(prevTitle);

                render(popupContent[0], close, model);

                let title = actualOptions.pageTitle || ko.unwrap(model).pageTitle;

                if (ko.isObservable(title)) {
                    titleSubscription = title.subscribe($.cdh.helper.titlePage);
                }
                $.cdh.helper.titlePage(ko.unwrap(title));

                scrollPosition = $(window).scrollTop();
                mainContent.hide();
                popupContent.show();
                tooltipsInit();
                window.scrollTo(0, 0);

                return false;
            });

        } else {
            $(element).magnificPopup({
                enableEscapeKey: false,
                closeOnBgClick: false,
                items: {
                    src: '<div></div>',
                    type: 'inline'
                },
                callbacks: {
                    open: function () {
                        let actualOptions = valueAccessor();
                        let renderIn = this.content[0];
                        let model = getModel(actualOptions);

                        render(renderIn, this.close, model);

                        setTimeout(function() {
                            let title = actualOptions.pageTitle || ko.unwrap(model).pageTitle;

                            if (title && title.length > 0)
                                setPageTitle(title, $(".magnific-popup-container"), ".popup-form_title");

                            tooltipsInit();
                            var popupContainer = $(renderIn).find('.magnific-popup-container');
                            popupContainer.find('.popup-form_title').attr('id', 'popup-form_title').after('<button title="Close (Esc)" type="button" class="mfp-close" aria-label="close">×</button>');
                            
                            $(popupContainer).on("click keydown", function (e) {
                                var firstFocusable = $(popupContainer).find('.mfp-close');
                                var lastFocusable = $(popupContainer).find(':focusable').eq(-1);
                                if (document.activeElement === firstFocusable[0] && e.shiftKey && e.key === 'Tab') {
                                            lastFocusable.focus();
                                            e.preventDefault();
                                }

                                else if (document.activeElement === lastFocusable[0] && e.key === 'Tab' && !e.shiftKey) {
                                        firstFocusable.focus();
                                        e.preventDefault();
                                }
                            })
                        }, 0);
                    }
                }
            });
        }

        $(element).on("click keydown", function (e) { e.stopImmediatePropagation(); });

        let forceOpen = options.forceOpen;
        if(ko.isSubscribable(forceOpen)) {
            forceOpen.subscribe(function(newValue) {
                if(newValue === true) {
                    $(element).click();
                }
            });
        }
        else if (forceOpen) {
            $(element).click();
        }
    }
};

ko.bindingHandlers.popup = {
    init: function (element, valueAccessor) {

        var options = valueAccessor();
        var showAsPage = options.showAsPage || $.cdh.isMobile;
        if (showAsPage) {
            var title = options.title;
            var originTitle = $(".title-page").text();
            var mainContent = $(".content").children().first();
            var popupContent = $("#popup-content");
            var scrollPosition = 0;
            var titleSubscription = null;

            function close() {
                if (titleSubscription && $.isFunction(titleSubscription.dispose)) {
                    titleSubscription.dispose();
                }
                $(".title-page").text(originTitle);
                $("#header-title").text(originTitle);
                mainContent.show();
                popupContent.hide();

                /* WCP-2989: when we restore our main layout, we can refresh charts in gridstack widgets */
                $(window).trigger('resize'); // for charts refresh

                updateContainerHeight(element)();

                //Scroll on top after all
                if (scrollPosition) {
                    window.scrollTo(0, scrollPosition);
                }
            }

            function setPageTitle(title) {
                var titleText = ko.unwrap(title);
                if (titleText) {
                    $(".title-page").text(titleText);
                    $("#header-title").text(titleText);
                }
            }

            $(element)
                .on("click",
                    function(e) {
                        var renderIn = popupContent;
                        var binding = ko.unwrap(valueAccessor());
                        var template = ko.unwrap(binding.template);
                        var params = ko.unwrap(binding.params);

                        binding.title = $.cdh.helper.htmlDecode(binding.title);

                        var model = binding.modelBuilder != null
                            ? binding.modelBuilder(params)
                            : new binding.model(params);

                        model.DisplayedAsPage = true;

                        var setClose = ko.unwrap(model).setClose;
                        if ($.isFunction(setClose))
                            setClose(close);

                        var preRender = ko.unwrap(model).preRender;
                        if ($.isFunction(preRender))
                            preRender();
                        else{
                            var initialize = ko.unwrap(model).initialize;
                            if($.isFunction(initialize))
                                initialize();
                        }

                        if (title) {
                            $(".title-page").text(title);
                            $("#header-title").text(title);
                        } else {
                            var pageTitle = options.pageTitle || ko.unwrap(model).pageTitle;
                            if (ko.isObservable(pageTitle)) {
                                titleSubscription = pageTitle.subscribe(setPageTitle);
                            }
                            setPageTitle(pageTitle);
                        }

                        ko.renderTemplate(template, model, {}, renderIn[0], 'replaceChildren');

                        scrollPosition = $(window).scrollTop();
                        popupContent.show();
                        mainContent.hide();
                        tooltipsInit();
                        /* WCP-2989: Comment that line - it make gridstack to collapse all widgets if it hidden (resize on window make gridstack to resize also) */
                        //$(window).trigger('resize'); // for charts refresh

                        e.stopImmediatePropagation();
                        return false;
                    });

        } else {
            $(element)
                .magnificPopup({
                    enableEscapeKey: false,
                    closeOnBgClick: false,
                    items: {
                        src: '<div></div>',
                        type: 'inline'
                    },
                    callbacks: {
                        open: function () {
                            var renderIn = this.content[0];
                            var binding = ko.unwrap(valueAccessor());
                            var template = ko.unwrap(binding.template);
                            var params = ko.unwrap(binding.params);

                            binding.title = $.cdh.helper.htmlDecode(binding.title);

                            var model = binding.modelBuilder != null
                                ? binding.modelBuilder(params)
                                : new binding.model(params);

                            model.DisplayedAsPage = false;

                            var setClose = ko.unwrap(model).setClose;
                            if ($.isFunction(setClose))
                                setClose(this.close);

                            var preRender = ko.unwrap(model).preRender;
                            if ($.isFunction(preRender))
                                preRender();
                            else{
                                var initialize = ko.unwrap(model).initialize;
                                if($.isFunction(initialize))
                                    initialize();
                            }

                            ko.renderTemplate(template, model, {}, renderIn, 'replaceChildren');
                            tooltipsInit();
                            const $popupContainer = $(renderIn).find('.magnific-popup-container');

                            if ($popupContainer.length) {
                                $popupContainer.attr({
                                    'role': 'dialog',
                                    'aria-modal': 'true',
                                    'aria-labelledby': 'popup-form_title'
                                });
                            }

                            $popupContainer.find('.popup-form_title').attr('id', 'popup-form_title').after('<button title="' + $.cdh.languageConstant.getConstant('button.close-esc') +'" type="button" class="mfp-close" aria-label="close">×</button>'); 
                            $($popupContainer).on("click keydown", function (e) {
                                var firstFocusable = $($popupContainer).find('.mfp-close');
                                var lastFocusable = $($popupContainer).find(':focusable').eq(-1);
                                if (document.activeElement === firstFocusable[0] && e.shiftKey && e.key === 'Tab') {
                                    lastFocusable.focus();
                                    e.preventDefault();
                                }

                                else if (document.activeElement === lastFocusable[0] && e.key === 'Tab' && !e.shiftKey) {
                                    firstFocusable.focus();
                                    e.preventDefault();
                                }
                            })
                            // $(renderIn).find('.magnific-popup-container').attr('role', 'dialog').attr('aria-modal', 'true').attr('aria-labelledby', 'popup-form_title');
                        }
                    }
                });
        }


        $(element)
            .on("click",
                function (e) {
                    e.stopImmediatePropagation();
                    return false;
                });

        $(element).on('keydown', function (e) {
            if (e.keyCode === 32 || e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                $(element).click();
            }
        });

        let forceOpen = options.forceOpen;
        if(ko.isSubscribable(forceOpen)) {
            forceOpen.subscribe(function(newValue) {
                if(newValue === true) {
                    $(element).click();
                }
            });
        }
        else if (forceOpen) {
            $(element).click();
        }
    }
};


